import React from 'react';

const RestaurantListIcon = ({ size = '25px', color = '#fff' }) => {
  return (
    <svg
      id='b'
      data-name='Capa 2'
      xmlns='http://www.w3.org/2000/svg'
      viewBox='0 0 212.93 261.49'
      width={size}
      height={size}
    >
      <g id='c' data-name='OBJECTS'>
        <g>
          <path
            d='M115.61.27c.98.45,3.26.69,4.7.9,5.87.87,11.33,2.21,16.83,4.27,23.6,8.84,42.81,27.57,52.08,51.87,4.65,12.19,6.69,27.27,4.53,41.43-.82,5.38-1.98,9.92-3.42,15.59-.67,2.62-2.81,7.2-3.87,9.79-12.41,30.06-35.3,58.7-58.43,83.3-4.7,5-9.72,10.51-15.01,14.9-1.5,1.24-1.69,1.42-3.51,2.17-.09.04-.09.38-.27.43-.57.14-4.48.12-5.19.03-.48-.06-.32-.47-.56-.53-.28-.07-.69.08-.92-.02-.21-.09-.15-.37-.41-.49-2.11-.98-4.01-3.35-5.8-5.05-26.81-25.45-55.2-60.62-69.24-93.55-3.88-9.1-6.63-17.08-8.06-27.3C13.68,59.63,37.36,20.43,73.82,6.36c6.01-2.39,13.52-4.83,20.07-5.64,2.63-.32,20.19-1.15,21.71-.45ZM110.39,57.96c-2.32-1.07-12.18.82-14.48,1.68s-5.49,2.53-7.44,3.98c-5.1,3.8-9.1,9.59-11.04,15.39-.16.49-.62,1.65-.64,1.75-.14.6.13,1.39-.01,1.99-.05.2-.46.16-.51.36-.23.96-.19,8.67-.03,9.89.06.48.49.34.54.55.28,1.19.14,2.43.6,3.79.69,2.06,1.83,4.24,2.77,5.9.58,1.03,1.86,3.37,2.46,4.14,3.93,5.01,12.32,9.81,18.07,10.77,5.85.98,12.33.34,17.32-1.7,19.63-8.02,25.21-33.8,10.62-49.07-3.26-3.42-7.34-6.12-11.67-7.8-2.1-.81-4.84-.83-6.57-1.63Z'
            fill={color}
          />
          <path
            d='M38.61,170.2c.26.09,2.64,3.93,3.05,4.51,9.66,13.46,20.7,26.03,32.24,38.42.58.62,2.16,1.99,2.32,2.18.15.18-.05.67.1.94.06.11.63.3.87.57,4.39,4.83,10.51,11.35,15.5,15.3,1.48,1.17,5.31,3.93,6.99,4.29,5.78,1.22,10.87,1.46,16.33-1.31,5.96-3.59,11.55-9.56,16.63-14.81,14.11-14.59,27.13-30.42,39-46.42.94-1.26,2.07-2.43,2.97-3.73,1.72-.36,2.21.54,3.54,1.09,4.04,1.64,8,3.58,11.99,5.96,8.84,5.28,16.89,12.62,20.91,22.61,1.66,4.13,2.41,9.11,1.5,14.08-.22,1.22-.29,2.98-.55,4.1-.05.2-.47.16-.51.36-.92,4.18-4.08,9.24-7.14,12.78-1.89,2.18-4.43,4.64-6.45,6.17-6.86,5.19-12.74,8.52-20.52,11.76-9.26,3.86-19.74,7.06-30.25,9.03-4.7.88-10.5,1.76-15.65,2.36-12.78,1.49-25.8.94-38.9,1.07-1.46-1.06-4.07-.4-5.98-.55-4.08-.3-8.5-1.19-12.55-1.8-9.48-1.43-19.03-3.24-28.36-6.31-14.5-4.76-33.4-13.42-41.93-28.65-4.35-7.77-4.94-16.93-1.5-25.28,5.07-12.31,19.84-22.67,31.44-27.47,1.12-.46,3.92-1.58,4.94-1.25Z'
            fill={color}
          />
        </g>
      </g>
    </svg>
  );
};

export default RestaurantListIcon;
